module.exports = __webpack_public_path__ + "static/media/1023486.ad839761.png";